import React, { Component } from "react";
import "./Comments.css";
import send from "../assets/icon_send.svg";
import { withFirebase } from "../Firebase";
import { withRouter } from "react-router-dom";


class AddComment extends Component {
  constructor(props) {
    super(props);
    this.state = { comments: [], current_uid: [], comment: {}, user: [], cache: "" };
  }

  componentDidMount() {
    let uid;
    if (this.props.firebase.auth.currentUser) {
      uid = this.props.firebase.auth.currentUser.uid
      this.setState({ current_uid: uid })

      this.props.firebase.db
        .collection("users")
        .doc(uid)
        .get()
        .then(doc => {
          let user = doc.data()
          this.setState({
            user: user,
            comment: { comment: '', creatorId: uid, creator: user }
          })
        });

      if (this.props.idCapsule) {
        this.props.firebase.db.collection('capsules')
          .doc(this.props.idCapsule)
          .collection('ideas')
          .doc(this.props.idCard)
          .get()
          .then((doc) => {
            this.setState({ comments: doc.data().comments ? doc.data().comments : [] })
          })
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentComments !== this.state.comments) {
      this.setState({ comments: nextProps.currentComments })
    }
  }


  onSubmitCommment = (e) => {
    e.preventDefault();
    let { comments, comment } = this.state;
    if (!comments) {
      comments = [];
    }
    if (comment.comment.trim().length > 0) {
      comments.push(comment)
      this.setState({
        comments, test: null
      })
      if (this.props.idCapsule) {
        this.props.firebase.db.collection('capsules')
          .doc(this.props.idCapsule)
          .collection('ideas')
          .doc(this.props.idCard)
          .set({ comments: comments }, { merge: true })
          .catch(error => {
            console.error(error);
          })
      }
      this.props.addComments(comments);
      this.setState({ cache: "" });
    }
  }

  onChangeComment = (event) => {
    const { current_uid, user } = this.state;
    this.setState({ cache: event.target.value });
    this.setState({ comment: { comment: event.target.value, creatorId: current_uid, creator: user } })
  }

  render() {
    return (
      <div className="add-com pt-4">
        <form onSubmit={this.onSubmitCommment} method="POST">
          <div className="d-flex">
            <input value={this.state.cache} onChange={this.onChangeComment} className="input-com pl-3" required />
            <button className="no-border transparent" type="submit"><img alt="send" src={send} /></button>
          </div>
        </form>
      </div>
    );
  }
}


const AddCommentConnected = withRouter(withFirebase(AddComment));

export { AddCommentConnected as AddComment }